import api_fetch from '../utils/api_fetch';
import { storageHandler } from '../utils/storage_handler';

const reportsService = {
  generateReport: async function (params = {}) {
    const { table, filters, dateRange } = params;

    const queryParams = new URLSearchParams();
    queryParams.append('table', table);

    if (dateRange?.from) {
      queryParams.append('date_from', dateRange.from);
    }
    if (dateRange?.to) {
      queryParams.append('date_to', dateRange.to);
    }

    if (filters && filters.length > 0) {
      queryParams.append('filters', JSON.stringify(filters));
    }

    return (
      await api_fetch.get(
        `/v1/reports/generate?${queryParams.toString()}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  },

  getTableColumns: async function (tableName) {
    return (
      await api_fetch.get(
        `/v1/reports/columns/${tableName}`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        {},
        '',
        {}
      )
    ).json();
  }
};

export default reportsService;
